// Size Guide Popup – JS (defer safe, portal to <body>)
(function(){
  function portalToBody(el){
    if (!el) return;
    if (!el.hasAttribute('data-sg-ported')) {
      // Sposta il modal direttamente sotto <body> per uscire da stacking context dell'header
      document.body.appendChild(el);
      el.setAttribute('data-sg-ported','true');
    }
  }

  function openModal(id){
    var el=document.getElementById(id);
    if(!el) return;
    portalToBody(el);
    el.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow='hidden';
    var c=el.querySelector('[data-sg-close]');
    if(c) c.focus();
  }

  function closeModal(el){
    if(!el) return;
    el.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow='';
  }

  document.addEventListener('click',function(e){
    // Apri
    var opener=e.target.closest('[data-sg-open]');
    if(opener){ e.preventDefault(); openModal(opener.getAttribute('data-sg-open')); return; }

    // Chiudi con X
    var closer=e.target.closest('[data-sg-close]');
    if(closer){ e.preventDefault(); closeModal(closer.closest('.sg-modal')); return; }

    // Chiudi clic su backdrop
    var backdrop=e.target.closest('.sg-backdrop');
    if(backdrop){ closeModal(backdrop.closest('.sg-modal')); return; }

    // Extra: chiudi cliccando fuori dal dialog
    var openModalEl=document.querySelector('.sg-modal[aria-hidden="false"]');
    if(openModalEl){
      var dialog=openModalEl.querySelector('.sg-dialog');
      if(dialog && !dialog.contains(e.target) && !e.target.closest('[data-sg-open]')){
        closeModal(openModalEl);
      }
    }
  });

  // ESC per chiudere
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){
      var m=document.querySelector('.sg-modal[aria-hidden="false"]');
      if(m) closeModal(m);
    }
  });
})();
